<script setup>
import { ref, onMounted, computed, inject, onUnmounted } from "vue"
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import DateAndTime from '../components/DateAndTime.vue'
import CalendarWeek from '../components/CalendarWeek.vue'
import CalendarMonth from '../components/CalendarMonth.vue'
import CalendarAgenda from '../components/CalendarAgenda.vue'

import useCalendarEvents from '../composables/useCalendarEvents.js'

import { useSettingsStore } from '../stores/settings'
const settingsStore = useSettingsStore()

import { useUsersStore } from "../stores/users";
const userStore = useUsersStore()

const router = useRouter()

const { calendars } = storeToRefs(settingsStore)

const { events } = useCalendarEvents(
  import.meta.env.VITE_CORS_PROXY_URL,
  calendars
)


onMounted(async () => {
  await settingsStore.initializeCalendars();
})
</script>

<template>
  <div class="flex h-screen">
    <div class="lg:w-1/2 w-full h-full flex flex-col">
      <div class="flex-shrink-0">
        <DateAndTime />
      </div>
      <div class="flex-grow min-h-0">
        <CalendarMonth :events="events" />
      </div>
    </div>
    <div class="lg:w-1/2 w-full h-full overflow-y-auto">
      <CalendarAgenda :events="events" />
    </div>
  </div>
</template>
